export default function studioIsFiltered(searchParams, testStudio) {

  if (searchParams.testType && !testStudio.testTypes.includes(searchParams.testType)) {
    return true;
  }

  if (searchParams.countries.length > 0 && !searchParams.countries.includes(testStudio.locationData.cityData.countryData.id)) {
    return true;
  }

  if (searchParams.features.length > 0) {

    for (let el of searchParams.features) {
      if (!testStudio.features.filter(x => [1, 2, 3].includes(x.availability)).map(x => x.id).includes(el)) {
        return true;
      }
    }

  }

  return false;

}